import React from 'react';
import styled from 'styled-components';

export const ListLayout = styled.div`
    &&& {
        background: #fff;
        height: calc(100vh - 70px);
        padding: 44px 35px 0 25px;
        overflow: hidden;
    }
`;
